import { NewJoineeWorkflowNotificationPopupComponent } from '../components/new-joinee-workflow-notification-popup/new-joinee-workflow-notification-popup.component'
import { PendingFromEmployeeQueryNotificationPopupComponent } from '../components/pending-from-employee-query-notification-popup/pending-from-employee-query-notification-popup.component'
import { ResetPasswordComponent } from '../components/reset-password/reset-password.component'
import {
  ACTIVITY_RECEIVED,
  IN_PROGRESS,
  PENDING_WITH_ER,
  PENDING_WITH_DEPARTMENT,
  PENDING_WITH_EE,
  COMPLETED
} from './stats-cards'

export class GlobalConstants {
  public static readonly DOT = '.'

  public static readonly IST_OFFSET: string = 'UTC+0530'

  public static readonly ROUTING = {
    LOGIN: 'login',
    DASHBOARD: 'dashboard',
    ACTIVITY: 'activity',
    NEW: 'new',
    QUERY: 'query',
    PROFILE: 'profile',
    VIEW_OR_EDIT: 'view-edit',
    SETTINGS: 'settings',
    KNOWLEDGE_HUB: 'knowledge-hub',
    VIEW_INFO: 'view-info',
    ID: ':id',
    DETAILS: 'details',
    SEARCH: 'search',
    QUICK_SELECT: 'quick-select',
    VIEW: 'view',
    LIST: 'search-list',
    FORM11_WORKFLOW: 'form11-workflow',
    STATUS: 'status',
    PARAM_STATUS: ':status',
    HELP: 'help',
    TUTORIAL_INFO: 'tutorial-info',
    SUMMARY: 'summary',
    FEEDBACK: 'feedback',
    COMPANY_DOMAIN: ':companyDomain'
  }

  public static readonly MODULE = {
    ACTIVITY_TRACKER: 'ACTIVITY_TRACKER',
    GOVERNMENT_BUSINESS_TASK: 'GOVERNMENT_BUSINESS_TASK',
    CALENDAR: 'CALENDAR',
    CIRCULAR_AND_COMMUNICATION: 'CIRCULAR_AND_COMMUNICATION',
    DASHBOARD: 'DASHBOARD',
    KNOWLEDGE_BANK: 'KNOWLEDGE_BANK',
    DOCUMENT_REPOSITORY: 'DOCUMENT_REPOSITORY',
    QUERIES: 'QUERIES',
    VIEW_INFO: 'VIEW_INFO'
  }

  public static readonly SORT_COLUMN = {
    CREATED_DATETIME: 'createdDatetime'
  }

  public static readonly DOCUMENT_TYPE = {
    ACTIVITY_DOC: 'ACTIVITY_DOC',
    QUERY_DOC: 'QUERY_DOC',
    FORM11: 'FORM_11'
  }

  public static readonly TASK_TYPE = {
    OFFLINE: 'Offline',
    ONLINE: 'Online'
  }

  public static readonly OPTION_TYPE = {
    GENDER: 'GENDER',
    MARITAL_TYPE: 'MARITAL_TYPE',
    NATIONALITY: 'NATIONALITY',
    CITY: 'CITY',
    STATE: 'STATE',
    COUNTRY: 'COUNTRY',
    EMPLOYMENT_DEPARTMENT: 'EMPLOYMENT_DEPARTMENT',
    EMPLOYMENT_BRANCH: 'EMPLOYMENT_BRANCH',
    EMPLOYMENT_CATEGORY: 'EMPLOYMENT_CATEGORY',
    EMPLOYMENT_LOCATION: 'EMPLOYMENT_LOCATION',
    EMPLOYMENT_TYPE: 'EMPLOYMENT_TYPE',
    YES_NO: 'YES_NO',
    RELATIONSHIP_TYPE: 'RELATIONSHIP_TYPE'
  }

  public static readonly DYNAMIC_MODEL = {
    RESET_PASSWORD: { key: 'RESET_PASSWORD', component: ResetPasswordComponent },
    NEW_JOINEE_WORKFLOW_NOTIFICATION_POPUP: {
      key: 'NEW_JOINEE_WORKFLOW_NOTIFICATION_POPUP',
      component: NewJoineeWorkflowNotificationPopupComponent
    },
    PENDING_FROM_EMPLOYEE_NOTIFICATION_POPUP: {
      key: 'PENDING_FROM_EMPLOYEE_NOTIFICATION_POPUP',
      component: PendingFromEmployeeQueryNotificationPopupComponent
    }
  }

  public static readonly employeeMinAge: number = 14

  public static readonly CATEGORY_TYPE = {
    PT: 'PT',
    LABOUR: 'Labour',
    ESI: 'ESI',
    EPF: 'EPF',
    OTHER_LLC: 'Other LLC',
    LLC: 'LLC' // this type applies only to Knowledge article
  }

  public static readonly COMPANY_SETTINGS_TYPE = {
    MODULES: 'MODULES',
    NOTIFICATION_PREFERENCES: 'NOTIFICATION_PREFERENCES'
  }

  public static readonly NOTIFICATION_PREFERENCES = {
    SMS: 'SMS',
    EMAIL: 'EMAIL',
    WHATSAPP: 'WHATSAPP'
  }

  public static readonly FILE_UPLOAD_CONFIG = {
    maxAllowedSizeInBytes: 2097152,
    maxFilesPerSelection: 10,
    allowedFileMimeTypes: [
      'application/pdf',
      'image/jpeg',
      'image/png',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'message/rfc822'
    ],
    allowedInputAccept: '.jpeg, .jpg, .png, .pdf, .xls, .xlsx, .doc, .docx, .eml',
    documentAndMimeTypeMapping: {
      'application/pdf': 'PDF',
      'image/jpeg': 'JPEG',
      'image/png': 'PNG',
      'application/vnd.ms-excel': 'EXCEL',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'EXCEL',
      'application/msword': 'DOCX',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
      'message/rfc822': 'EML'
    }
  }

  public static readonly DocType = {
    PAN: 'PAN',
    AADHAAR: 'AADHAAR'
  }

  public static readonly TUTORIAL_VIDEO_OPTIONS = [
    {
      id: 1,
      name: 'Features of SmartOperator',
      description: 'Watch this short video to understand the features that are available in SmartOperator.',
      url: 'https://www.youtube.com/watch?v=9Lzaf_hVaGY'
    },
    /*{
      id: 2,
      name: 'How does an Activity-board work?',
      description: 'By watching this video you will know what is an activity and how you can create one.',
      url: 'https://www.youtube.com/embed/QtFNbYIS2js?si=VBDCFX1j-PAhO65c'
    },*/
    {
      id: 3,
      name: 'How to create a query?',
      description: 'In this video you will learn how to create a query and the options available in it.',
      url: 'https://www.youtube.com/watch?v=kQGMsFJ98vY'
    },
    {
      id: 4,
      name: 'How to submit the form 11 new joinee process?',
      description:
        'This video is for new joiners who needs to submit the new joinee workflow (form 11) process in the tool.',
      url: 'https://www.youtube.com/embed/6VCoLykEVL8?si=C_XmXlNmPPMFTEy_'
    },
    {
      id: 5,
      name: 'Complete Tutorial of SmartOperator',
      description: 'This video covers the demo of the entire tool.',
      url: 'https://www.youtube.com/embed/1pHBIEyiG68?si=BKGbcVTXbZrr7RrW'
    }
  ]

  public static readonly TUTORIAL_VIDEO_OPTIONS_COMMON = [
    {
      id: 1,
      name: 'SOP Activity Board',
      description: 'Watch this video to understand how the Activity Board works.',
      url: 'https://www.youtube.com/embed/u1TD1S2ONZs?si=RENhKSg1jloVKoah'
    },
    {
      id: 2,
      name: 'SOP Query Section',
      description: 'Watch this video to understand how the Query section works.',
      url: 'https://www.youtube.com/embed/icTKhGuCCTI?si=TfoEBz4zWsl04NR7'
    },
    {
      id: 3,
      name: 'How to Access SmartOperator',
      description: 'Watch this video to learn how to access and log in to SmartOperator.',
      url: 'https://www.youtube.com/embed/oY7qLbv6z6E?si=9uPtSwoTSshIywYl'
    }
  ]

  public static readonly FILE_DOWNLOAD_CONFIG = {
    ROW_LIMIT: 1000000,
    PAGE_NUMBER: 0
  }

  public static readonly DATE_FORMAT = {
    'MM/YYYY': 'MM/YYYY',
    'YYYY/MM': 'YYYY/MM',
    'MM-YYYY': 'MM-YYYY',
    'YYYY-MM': 'YYYY-MM',
    'DD/MM/YYYY': 'DD/MM/YYYY',
    'MM/DD/YYYY': 'MM/DD/YYYY',
    'YYYY/MM/DD': 'YYYY/MM/DD',
    'YYYY/DD/MM': 'YYYY/DD/MM',
    'DD-MM-YYYY': 'DD-MM-YYYY',
    'MM-DD-YYYY': 'MM-DD-YYYY',
    'YYYY-MM-DD': 'YYYY-MM-DD',
    'MM-YYYY-DD': 'MM-YYYY-DD',
    YYYY: 'YYYY'
  }

  public static readonly ACTIVITY_STATUS_LIST = [
    ACTIVITY_RECEIVED,
    IN_PROGRESS,
    PENDING_WITH_ER,
    PENDING_WITH_DEPARTMENT,
    PENDING_WITH_EE,
    COMPLETED
  ]

  public static readonly FEEDBACK_STATUS = {
    INITIATED: 'INITIATED',
    CLOSED: 'CLOSED',
    DISMISSED: 'DISMISSED'
  }

  public static readonly FEEDBACK_UI_STATUS = {
    INTERACTED: 'INTERACTED',
    NOT_INTERACTED: 'NOT-INTERACTED'
  }
}
